import React from 'react';
import Careers from '../../components/careers';

const CareersPage = () => {
  return (
    <>
      <Careers />
    </>
  );
};

export default CareersPage;
